import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ADMIN_ROLES, EMPLOYEE_ROLES } from '../constants';
import ProtectedRoute from './ProtectedRoute';
import AuthLayout from '../layouts/AuthLayout';
import EmployeeLayout from '../layouts/EmployeeLayout';
import AdminLayout from '../layouts/AdminLayout';

// Auth
import LoginPage from '../modules/auth/LoginPage';
import TemaAuthPage from '../modules/auth/TemaAuthPage';

// Employee pages
import EmployeeReportsPage from '../modules/employee/pages/ReportsPage';
import EmployeeReportDetailPage from '../modules/employee/pages/ReportDetailPage';
import EmployeeProfilePage from '../modules/employee/pages/ProfilePage';

// Admin pages
import AdminDashboardPage from '../modules/admin/pages/DashboardPage';
import AdminUsersPage from '../modules/admin/pages/UsersPage';
import AdminUserDetailPage from '../modules/admin/pages/UserDetailPage';
import AdminCompaniesPage from '../modules/admin/pages/CompaniesPage';
import AdminUniformCategoriesPage from '../modules/admin/pages/UniformCategoriesPage';
import AdminUniformsPage from '../modules/admin/pages/UniformsPage';
import AdminUniformReportsPage from '../modules/admin/pages/UniformReportsPage';
import AdminUniformComparisonPage from '../modules/admin/pages/UniformComparisonPage';
import AdminUniformReportDetailPage from '../modules/admin/pages/UniformReportDetailPage';
import AdminMissingReportsPage from '../modules/admin/pages/MissingReportsPage';

const AppRoutes = () => {
  const { isAuthenticated, user } = useAuth();

  const defaultRedirect = () => {
    if (!isAuthenticated) return '/login';
    if (ADMIN_ROLES.includes(user?.role)) return '/admin/dashboard';
    return '/employee/reports';
  };

  return (
    <Routes>
      {/* ===== Auth ===== */}
      <Route element={<AuthLayout />}>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to={defaultRedirect()} replace /> : <LoginPage />}
        />
        {/* Employee auto-login dari TEMA: /auth/tema?tema_api_key=xxx&tema_user_id=yyy&name=...&email=...&phone=...&rso=... */}
        <Route path="/auth/tema" element={<TemaAuthPage />} />
      </Route>

      {/* ===== Employee ===== */}
      <Route
        element={
          <ProtectedRoute allowedRoles={EMPLOYEE_ROLES}>
            <EmployeeLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/employee/reports" element={<EmployeeReportsPage />} />
        <Route path="/employee/reports/:uniformReportId" element={<EmployeeReportDetailPage />} />
        <Route path="/employee/profile" element={<EmployeeProfilePage />} />
      </Route>

      {/* ===== Admin ===== */}
      <Route
        element={
          <ProtectedRoute allowedRoles={ADMIN_ROLES}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/companies" element={<AdminCompaniesPage />} />
        <Route path="/admin/uniform-categories" element={<AdminUniformCategoriesPage />} />
        <Route path="/admin/uniforms" element={<AdminUniformsPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/users/:userId" element={<AdminUserDetailPage />} />
        <Route path="/admin/uniform-reports" element={<AdminUniformReportsPage />} />
        <Route path="/admin/missing-reports" element={<AdminMissingReportsPage />} />
        <Route path="/admin/uniform-reports/compare" element={<AdminUniformComparisonPage />} />
        <Route path="/admin/uniform-reports/:uniformReportId" element={<AdminUniformReportDetailPage />} />
      </Route>

      {/* ===== Fallback ===== */}
      <Route path="*" element={<Navigate to={defaultRedirect()} replace />} />
    </Routes>
  );
};

export default AppRoutes;
